import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "./firebase-config";
const appId = 'analytebudget';

// Path: users/{userId}/budgetData/v1
export const getBudgetState = async (uid) => {
  const ref = doc(db, 'users', uid, 'budgetData', 'v1');
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
};

export const setBudgetState = async (uid, budgetState) => {
  const ref = doc(db, 'users', uid, 'budgetData', 'v1');
  await setDoc(ref, budgetState, { merge: true });
};

export const updateBudgetState = async (uid, updates) => {
  const ref = doc(db, 'users', uid, 'budgetData', 'v1');
  await updateDoc(ref, updates);
};

// Example structure for budgetState:
// {
//   tbb: number,
//   categories: [
//     { id, name, budgetedAmount, activityAmount, availableAmount, goalAmount }
//   ]
// }
